<template>
  <div class="login">
    <div class="logo-container">
      <img class="logo-name" src="../../../assets/images/login/logo-name.png" alt>
    </div>
    <div class="login-content">
      <div class="bg-container">
        <img class="bg-siping" src="../../../assets/images/login/siping.gif">
      </div>
      <div class="right-container">
        <div class="form-container">
          <div>
            <p class="sub-title">欢迎使用水晶</p>
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="loginRules"
              class="login-form"
              auto-complete="on"
              label-position="left"
            >
              <el-form-item prop="username">
                <span class="svg-container">
                  <img src="../../../assets/images/login/userName.png">
                </span>
                <el-input
                  ref="username"
                  v-model="loginForm.username"
                  type="text"
                  placeholder="请输入用户名"
                  @keyup.enter.native="loginIn('loginForm')"
                />
              </el-form-item>
              <el-form-item prop="password">
                <span class="svg-container">
                  <img src="../../../assets/images/login/passWord.png">
                </span>
                <el-input
                  ref="password"
                  v-model="loginForm.password"
                  @keyup.enter.native="loginIn('loginForm')"
                  type="password"
                  placeholder="请输入密码"
                />
              </el-form-item>
              <el-button
                type="primary"
                class="login-btn"
                @click.native.prevent="loginIn('loginForm')"
                >登录</el-button
              >
            </el-form>
          </div>
          <p class="tips">如若忘记密码，请主动联系运营人员</p>
        </div>
      </div>
    </div>
    <div class="copy">浙ICP备12004338号-5 | &copy;2020 杭州中仓供应链科技(集团)有限公司所有</div>
  </div>
</template>

<script>
import { saveToken, saveDBUserRealName, deleteToken } from "common/js/storage";
import User from "models/user";
const user = new User();
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
      },
    };
  },
  methods: {
    loginIn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let username = this.loginForm.username
          let password = this.loginForm.password
          let data = {
            username,
            password
          };
          user.postUserLogin(data).then(res => {
            if (res.success) {
              deleteToken()
              saveToken(res.result.token);
              saveDBUserRealName(res.result.username);
              this.$router.replace("/home");
            } else {
              this.$message.error(res.message)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .logo-container {
    height: 116px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 234px;
    background: #F2F4F8;
    box-sizing: border-box;
    .logo-name {
      width: 172px;
      height: 36px;
    }
  }
  .login-content {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .bg-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 77px;
      .bg-siping {
        width: 450px;
        height: 450px;
      }
    }
    .right-container {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      padding-left: 77px;
      align-items: center;
      background: #fff;
      box-sizing: border-box;
      .form-container {
        width: 462px;
        height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        border: 1px solid #E5E5E5;
        border-radius: 12px;
        box-shadow: 1px 1px 10px 1px rgba(51, 51, 51, 0.08);
        .sub-title {
          font-size: 26px;
          font-weight: 500;
          color: #333333;
          text-align: center;
          margin-top: 99px;
        }
        .login-form {
          width: 380px;
          margin: 0 auto;
          margin-top: 45px;    
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          /* svg样式 */
          .svg-container {
            position: absolute;
            width: 20px;
            height: 20px;
            left: 17px;
            top: 3px;
            z-index: 10;
            img {
              width: 20px;
              height: 20px;
            }
          }
          .login-btn {
            width: 100%;
            height: 48px;
            border-radius: 4px;
            background: #2e68ea;
            color: #fff;
          }
        }
        .tips {
          text-align: center;
          padding-bottom: 29px;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
  .copy {
    height: 128px;
    box-sizing:  border-box;
    text-align: center;
    color: #999;
    font-size: 14px;
    background: #F2F4F8;
    padding-top: 30px;
  }
}
</style>
<style lang="scss">
.login {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    display: flex;
    position: relative;
    height: 48px;
    .el-input,
    .el-input__inner {
      height: 48px;
      background: #f5f5f5;
    }
    .el-input__inner {
      padding-left: 55px;
      border: none;
      border-radius: 0px;
      font-size: 16px;
      color: #000;
      font-weight: 400;
    }
  }
}
</style>
